/**
 * Main registry module - now loads from generated JSON files.
 *
 * This file maintains backward compatibility with the old API while
 * using the new dynamic registry system under the hood.
 */

// Re-export everything from the new registry module
export * from './registry/index';

// Re-export types for convenience
export type { Rule, Language, Category, Severity } from './registry/types';
